import { addPuv } from '../../service'
const getAddPuv = {
  methods: {
    async getAddPuv(url, row_id) {
      let res = await addPuv({
        user_key: this.$store.state.user_key,
        url: url,
        row_id: row_id
      }, (error) => this.$Message.error('请求错误！'))
    }
  }
}
export { getAddPuv }
